import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buyerVendorsUpdate } from '../actions';
import { getBuyerFormFields, getBuyerFieldFetches, getBuyer } from '../selectors';
import VendorInfoView from '../components/VendorInfoView';


const VendorInfoContainer = props => <VendorInfoView {...props} />;

VendorInfoContainer.propsTypes = {
  buyerFetchFormFieldsAction: PropTypes.func.isRequired,
  buyerFormFieldFetches: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  buyer: getBuyer(state),
  buyerFormFields: getBuyerFormFields(state),
  buyerFormFieldFetches: getBuyerFieldFetches(state)
});

const mapDispatchToProps = dispatch => ({
  buyerVendorsUpdateAction: (...p) => dispatch(buyerVendorsUpdate(...p))
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorInfoContainer);
